import {Voivodeship, voivodeshipNames} from "../app/types/locationTypes";

/** Match PHP `sanitize_city_slug` in api-child/functions.php. */
const PL_TO_ASCII: Record<string, string> = {
    ą: "a",
    ć: "c",
    ę: "e",
    ł: "l",
    ń: "n",
    ó: "o",
    ś: "s",
    ź: "z",
    ż: "z",
    Ą: "a",
    Ć: "c",
    Ę: "e",
    Ł: "l",
    Ń: "n",
    Ó: "o",
    Ś: "s",
    Ź: "z",
    Ż: "z"
};

export const toCitySlug = (city: string): string =>
    city
        .trim()
        .split("")
        .map((ch) => PL_TO_ASCII[ch] || ch)
        .join("")
        .replace(/-/g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "")
        .toLowerCase();

export const VOIVODESHIP_FILTER_OPTIONS = (Object.values(Voivodeship) as Voivodeship[]).map((slug) => ({
    value: slug,
    label: voivodeshipNames[slug]
}));

export type CityFilterOption = {
    label: string;
    value: string;
    offerCount?: number;
};

export const mergeCityOptions = (withOffers: CityFilterOption[], allCityNames: string[]): CityFilterOption[] => {
    const bySlug = new Map<string, CityFilterOption>();

    withOffers.forEach((city) => {
        if (city.value) {
            bySlug.set(city.value, city);
        }
    });

    allCityNames.forEach((name) => {
        const slug = toCitySlug(name);
        if (!slug || bySlug.has(slug)) {
            return;
        }
        bySlug.set(slug, {label: name, value: slug});
    });

    return Array.from(bySlug.values()).sort((a, b) => {
        const aCount = a.offerCount ?? -1;
        const bCount = b.offerCount ?? -1;
        if (aCount !== bCount) {
            return bCount - aCount;
        }
        return a.label.localeCompare(b.label, "pl");
    });
};

export const locationParamFromValues = (location: string, subLocation: string): string | undefined => {
    if (!location) {
        return undefined;
    }
    return subLocation ? `${location}/${subLocation}` : location;
};
